module.exports = __webpack_public_path__ + "img/SC10-Cover_Costs.ac3d740b.png";